<main class="page-container">
    <div class="content-wrapper">
        <!-- Animated Icon Text -->
        <div class="error-container">
            <div class="error-text" [@floatAnimation]>
                403
            </div>
            <div class="floating-elements">
                <div class="floating-circle circle-1"></div>
                <div class="floating-circle circle-2"></div>
                <div class="floating-circle circle-3"></div>
            </div>
        </div>

        <!-- Oops Text -->
        <div class="oops-text" [@fadeInUp]>
            Access Denied
        </div>

        <!-- Content Text -->
        <div class="content-text" [@fadeInUp]>
            You don't have permission to view this page.
            Please contact your administrator if you believe this is a mistake.
        </div>

        <!-- Back Button -->
        <div class="button-container">
            <button class="primary-btn" (click)="goBack()" [@buttonPulse]>
                <span class="btn-text">Back to Dashboard</span>
            </button>
        </div>

        <!-- Additional decorative elements -->
        <div class="decoration">
            <div class="decoration-item decor-1"></div>
            <div class="decoration-item decor-2"></div>
            <div class="decoration-item decor-3"></div>
        </div>
    </div>
</main>